export const fonts = {
  heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
  body: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
};

export const fontSizes = {
  xs: 'clamp(0.875rem, 0.85rem + 0.1vw, 0.9375rem)',
  md: 'clamp(1rem, 0.95rem + 0.25vw, 1.125rem)',
  h3: 'clamp(1.25rem, 1.1rem + 0.75vw, 1.625rem)',
  h2: 'clamp(1.75rem, 1.3rem + 2.25vw, 2.75rem)',
  h1: 'clamp(2.125rem, 1.4rem + 3.6vw, 4rem)',
};

export const fontWeights = { normal: 400, semibold: 600, bold: 700 };

export const lineHeights = { tight: 1.15, snug: 1.3, base: 1.6 };
